export default __webpack_public_path__ + "assets/payment-icons/discover.52002dc641231e8e6fdc23c66fca12e6.svg";